import React from 'react';

import cx from 'classnames';

import { getAirOptionsLoader } from 'api/flightApi/searchForFlight';
import { BaseSelect } from 'components/shared/BaseFormComponents/Select';
import Button from 'components/shared/Button';
import Loader from 'components/shared/Loader';

import cs from '../../../index.module.css';
import { airOptionAdapter } from '../FlightTabs/Tabs/FlightApi/useFlightApi';
import { useFlightSearch } from '../functions';
import s from '../index.module.css';
import { ISearchBy } from '../types';
import { FlightDatePicker } from './FlightDatePicker';

export const SearchByAirports = ({
  hasSelectedValues,
  tripEvent,
  setSearchResults,
  setActiveItems,
  setShowSelect,
  organizedBy,
}: ISearchBy) => {
  const loadAirportOptions = getAirOptionsLoader(airOptionAdapter, 'airports');

  const {
    getFlightSchedulesByRoute,
    getAirportDefaultValue,
    loading,
    isDisabledAirportSearch,
    setArrivalAirportFsCode,
    setDepartureAirportFsCode,
    clearSearchResults,
    isTier2Subscription,
    isOrganizedByDay,
  } = useFlightSearch({
    hasSelectedValues,
    tripEvent,
    setSearchResults,
    setActiveItems,
    setShowSelect,
    organizedBy,
  });

  return (
    <div className={s.flightForm}>
      {loading && <Loader isFillBlock />}

      <FlightDatePicker tripEvent={tripEvent} clearSearchResults={clearSearchResults} />

      <div className={s.searchContainer}>
        <BaseSelect
          readOnly={!isTier2Subscription || isOrganizedByDay}
          placeholder="Departure Airport"
          defaultOption={getAirportDefaultValue(tripEvent.data.departureAirport)}
          loadOptions={loadAirportOptions}
          onChange={(name, id, config) => setDepartureAirportFsCode(config?.fsCode)}
        />
        <BaseSelect
          readOnly={!isTier2Subscription || isOrganizedByDay}
          placeholder="Arrival Airport"
          defaultOption={getAirportDefaultValue(tripEvent.data.arrivalAirport)}
          loadOptions={loadAirportOptions}
          onChange={(name, id, config) => setArrivalAirportFsCode(config?.fsCode)}
        />
        <Button
          disabled={isDisabledAirportSearch || !isTier2Subscription}
          onClick={getFlightSchedulesByRoute}
          className={cx(cs.buttonText, s.searchButton)}
          size="large"
          htmlType="button"
        >
          Search
        </Button>
      </div>
    </div>
  );
};
